import { ResourceType } from '../types/Resource';
import { Role } from '../types/AccessResource';
export const mapScopeToAccessResource = (scope) => {
    var _a, _b, _c;
    return ({
        id: scope.id,
        role: scope.role ? Role[scope.role] : undefined,
        resourceType: ((_a = scope.resource) === null || _a === void 0 ? void 0 : _a._entity)
            ? ResourceType[scope.resource._entity.toUpperCase()]
            : undefined,
        resourceId: ((_b = scope.resource) === null || _b === void 0 ? void 0 : _b.id) || scope.resourceId,
        title: (_c = scope.resource) === null || _c === void 0 ? void 0 : _c.title,
    });
};
